import React, { useEffect } from 'react';

import { Flex } from '@chakra-ui/react';
import { addYears, startOfDay } from 'date-fns';
import { useSelectedView } from 'reducers/viewsSlice';
import { useLevelUpAnalytics } from 'screens/analytics/continuousFeedback/context';

import { thisQuarter } from 'constants/ProjectConstants';
import { getDateRangeFromLS } from 'constants/helper';
import { localStorageKeys } from 'constants/localStorageKeys';
import { sendChangedTimelineEvent } from 'constants/mixpanelHelper';

import { DateRangeDropdown } from 'uiToolkitV1/DateRange';

import { useSelectCompetenciesSelectedIntent } from '../slice/CompetenciesIntentSlice';
import { CFGroupBy } from './CFGroupBy';

const CompetenciesMetaFilters = () => {
  const { updateDateRange } = useLevelUpAnalytics();
  const { selectedIntent } = useSelectCompetenciesSelectedIntent() ?? {};

  const { showTimelineDropdown, showGroupByDropdown } = selectedIntent ?? {};

  const sideNavSelectedCohort = useSelectedView();

  useEffect(() => {
    // this is to set default date range in context.
    const dateRangeFromLS = getDateRangeFromLS(localStorageKeys.analyticsFeedbackFilters);
    updateDateRange(dateRangeFromLS ?? thisQuarter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex gap="12px">
      {showGroupByDropdown && <CFGroupBy />}
      {showTimelineDropdown && (
        <DateRangeDropdown
          // @ts-expect-error idk :(
          onSelect={(date) => {
            sendChangedTimelineEvent({
              eventProperties: {
                cohort: sideNavSelectedCohort?.name,
                cohortId: sideNavSelectedCohort?.id,
                source: 'Feedback',
              },
            });
            updateDateRange(date);
          }}
          minDate={new Date(2020, 5, 1, 0, 0, 0, 0)}
          maxDate={addYears(startOfDay(new Date()), 5)}
          initialDateRange={getDateRangeFromLS(localStorageKeys.analyticsFeedbackFilters) ?? thisQuarter}
          showPredefinedRanges
          variant="chip"
        />
      )}
    </Flex>
  );
};

export { CompetenciesMetaFilters };
